import Logout from "@components/Logout/Logout.components";
import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, useMediaQuery } from "@mui/material"
import { Link, useLocation } from "@tanstack/react-router";
import ContactSupport from "icons/ContactSupport";
import CreditsIcon from "icons/Credits.icon";
import HistoryIcon from "icons/History.icon";
import RequestFeature from "icons/RequestFeature";
import TechnologiesIcon from "icons/Technologies.icon";
import UserIcon from "icons/User.icon";
import { useEffect, useState } from "react";
import authStore from "store/authStore";
import theme from "theme";

interface SidebarProps {
    handleSidebar: () => void;
    showSidebar: boolean,
    handleRequestFeature?: () => void;
}

const Sidebar = ({handleSidebar, showSidebar, handleRequestFeature}:SidebarProps) => {

    //Uzimamo podatke iz state-a logovanog korisnika
    const {authData} = authStore();
    const roles = authData.roles;
    const location = useLocation();

    const test = () => {
        console.log('asdsadads');
    }

    // Proveravamo da li je mobilni
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const links = [
        {
            to: '/profile/info',
            label: 'My profile',
            icon: (isActive: false | Record<never, string>) => (
            <UserIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['BasicUser', 'Admin', 'SuperAdmin'], 
        },
        {
            to: '/technologies',
            label: 'Technologies',
            icon: (isActive: false | Record<never, string>) => (
            <TechnologiesIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['BasicUser'], 
        },
        {
            to: '/history',
            label: 'Interview history',
            icon: (isActive: false | Record<never, string>) => (
            <HistoryIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['BasicUser']
        },
        {
            to: '/credits',
            label: 'Buy Credits',
            icon: (isActive: false | Record<never, string>) => (
            <CreditsIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['BasicUser', 'Admin', 'SuperAdmin'], 
        },
        {
            to: '/admin-dashboard',
            label: 'Main Dashboard',
            icon: (isActive: false | Record<never, string>) => (
            <TechnologiesIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['Admin', 'SuperAdmin'], 
        },
        {
            to: '/admin-companies',
            label: 'Companies',
            icon: (isActive: false | Record<never, string>) => (
            <HistoryIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['SuperAdmin'], 
        },
        {
            to: '/create-interview-step1',
            label: 'b2b-interview',
            icon: (isActive: false | Record<never, string>) => (
            <HistoryIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['SuperAdmin', 'Admin'], 
        },
        {
            to: '/created-interviews',
            label: 'created-interviews',
            icon: (isActive: false | Record<never, string>) => (
            <HistoryIcon color={isActive ? 'white' : '#020511'} />
            ),
            allowedRoles: ['SuperAdmin', 'Admin'], 
        },
    ];

    const handleContactSupport = () => {
        window.location.href = 'mailto:support@interviewer.com';
    };

    const sidebarContent = (
        <Box sx={{
            backgroundColor: '#fff',
            height: "100vh",
            overflowY: "auto",
        }}>
            <List sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px'
            }}>
                {links
                    .filter(link => link.allowedRoles.some(role => roles.includes(role)))
                    .map((link,index) => {
                        const isActive = location.pathname.startsWith(link.to);
                        return (
                            <ListItemButton
                                selected={isActive}
                                key={index}
                                component={Link}
                                to={link.to}
                                sx={{
                                    backgroundColor: "transparent",
                                    // kad je selected
                                    "&.Mui-selected": {
                                        backgroundColor: "var(--Interviewer-Green)",
                                    },
                                    // hover efekt
                                    "&:hover": {
                                        backgroundColor: isActive ? "var(--Interviewer-Green)" : "var(--Light-Gray)",
                                    },
                                    // hover kad je selected
                                    "&.Mui-selected:hover": {
                                        backgroundColor: "var(--Interviewer-Green)",
                                    },
                                }}
                            >
                                <ListItemIcon>{link.icon(isActive)}</ListItemIcon>
                                <ListItemText>
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            color: isActive ? "#FFFFFF" : "var(--Interviewer-Lighter-Black)", // bela ako je selected
                                        }}
                                    >{link.label}
                                    </Typography>
                                </ListItemText>
                            </ListItemButton>
                        )
                    })
                }

                <Divider />

                <ListItemButton onClick={handleContactSupport}>
                    <ListItemIcon><ContactSupport/></ListItemIcon>
                    <ListItemText>
                        <Typography
                            sx={{
                                fontSize: "16px",
                            }}
                        >Contact Support
                        </Typography>
                    </ListItemText>
                </ListItemButton>

                <ListItemButton onClick={handleRequestFeature}>
                    <ListItemIcon><RequestFeature/></ListItemIcon>
                    <ListItemText>
                        <Typography
                            sx={{
                                fontSize: "16px",
                            }}
                        >Request a feature
                        </Typography>
                    </ListItemText>
                </ListItemButton>
            </List>
        </Box>
    )

    if (isMobile) {
        return (
            <Drawer
                anchor="left"
                open={showSidebar}
                onClose={() => handleSidebar()}
                sx={{
                "& .MuiDrawer-paper": {
                    width: '280px',
                    boxSizing: "border-box",
                    padding: "24px",
                },
                }}
            >
                {sidebarContent}
                <Logout />
            </Drawer>
        );
    }

    return (
        <Box sx={{
            padding: '24px',
            width: '280px',
            minWidth: '280px',
            borderRight: "1px solid var(--Light-Gray, #F0F1F3)",
        }}>
            {sidebarContent}
        </Box>
    );

}

export default Sidebar